import React, { useEffect, useState } from "react"
import { PGET, POST } from "../../../helpers/api"

// Oy nomlari (Iyul, Avgust, ...)
export const MONTHS = [
	"Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun",
	"Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr",
]

// Ichki dilerlar id ro'yxati (backend "internal" flag bermaganda zaxira)
// Hozircha: Komiljon (1243), Samira (1244)
export const INTERNAL_DEALER_IDS = [1243, 1244]

// Diler bir yozuv ichki dilermi? Avval API flagi, keyin id ro'yxati
export const isInternalDealer = (r) =>
	r?.internal === true || r?.type === "INTERNAL" || INTERNAL_DEALER_IDS.includes(r?.id)

// Filter select variantlari
export const DEALER_TYPES = [
	{ value: "all", i18n: "Hammasi" },
	{ value: "internal", i18n: "Ichki dilerlar" },
	{ value: "other", i18n: "Boshqa dilerlar" },
]

// Tanlangan turga qarab qatorlarni filtrlash
export const filterByType = (rows, type) => {
	if (type === "internal") return rows.filter((r) => r.internal)
	if (type === "other") return rows.filter((r) => !r.internal)
	return rows
}

// Raqamni "2 600 000" ko'rinishida formatlash
export const fmt = (n) => String(Math.round(Number(n) || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, " ")

// Bajarilish foizi (reja 0 bo'lsa — null)
export const percentOf = (plan, fact) => (plan > 0 ? Math.round((fact / plan) * 100) : null)

// Foizga qarab rang
export const colorOf = (p) => {
	if (p === null) return { text: "#98a2b3", bar: "#e4e7ec", chip: "#f2f4f7" }
	if (p >= 90) return { text: "#067647", bar: "#12b76a", chip: "#ecfdf3" }
	if (p >= 60) return { text: "#b54708", bar: "#f79009", chip: "#fffaeb" }
	return { text: "#b42318", bar: "#f04438", chip: "#fef3f2" }
}

// Plan/Fakt ma'lumotlarini API'dan olish (ikkala sahifa uchun umumiy)
export function usePlanFactData(month, year) {
	const [rows, setRows] = useState([])
	const [loading, setLoading] = useState(false)

	async function reload() {
		setLoading(true)
		try {
			// GET /services/admin/api/plan-fact?year=2026&month=7
			const res = await PGET("/services/admin/api/plan-fact", { year, month }, { loader: true })
			const data = Array.isArray(res?.data) ? res.data : res?.data?.data
			setRows(
				(data || []).map((r) => {
					const id = r.dealerId ?? r.id
					return {
						id,
						name: r.name ?? r.fullName ?? "",
						plan: Number(r.plan) || 0,
						fact: Number(r.fact) || 0,
						internal: isInternalDealer({ ...r, id }),
					}
				})
			)
		} catch (e) {
			setRows([])
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		reload()
	}, [month, year]) // eslint-disable-line react-hooks/exhaustive-deps

	return { rows, setRows, loading, reload }
}

// Rejalarni saqlash — POST /services/admin/api/plan-fact
export async function savePlanItems(year, month, rows) {
	return POST("/services/admin/api/plan-fact", {
		year,
		month,
		items: rows.map((r) => ({ dealerId: r.id, plan: r.plan })),
	}, { loader: true })
}

// Ikkala sahifa uchun umumiy uslublar
export function PfStyles() {
	return (
		<style>{`
			.plan-fact { padding: 4px; }
			.pf-header {
				display: flex; justify-content: space-between; align-items: flex-start;
				flex-wrap: wrap; gap: 16px; margin-bottom: 18px;
			}
			.pf-title { font-size: 24px; font-weight: 700; color: #101828; margin: 0 0 4px; }
			.pf-subtitle { font-size: 14px; color: #667085; }
			.pf-controls { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
			.pf-select {
				height: 42px; border: 1px solid #e4e7ec; border-radius: 10px; padding: 0 14px;
				background: #fff; color: #344054; font-size: 14px; cursor: pointer; outline: none; min-width: 92px;
			}
			.pf-select:focus { border-color: #12b76a; }
			.pf-btn {
				height: 42px; padding: 0 22px; border-radius: 999px; font-size: 14px; font-weight: 600;
				cursor: pointer; border: 1px solid transparent; transition: all 0.15s ease;
			}
			.pf-btn:disabled { opacity: 0.6; cursor: not-allowed; }
			.pf-btn-outline { background: #fff; border-color: #12b76a; color: #12b76a; }
			.pf-btn-outline:hover:not(:disabled) { background: #ecfdf3; }
			.pf-btn-primary { background: #12b76a; color: #fff; }
			.pf-btn-primary:hover:not(:disabled) { background: #0ea15c; }
			.pf-card {
				background: #fff; border: 1px solid #eef0f3; border-radius: 16px;
				box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04); overflow: hidden;
			}
			.pf-row {
				display: grid; grid-template-columns: 2fr 1.4fr 1.2fr 1.6fr;
				align-items: center; gap: 16px; padding: 18px 24px; border-top: 1px solid #f2f4f7;
			}
			/* 2 ustunli variant (Plan sahifasi) */
			.pf-card.cols-2 .pf-row { grid-template-columns: 2fr 1.8fr; }
			/* Fakt sahifasi: Diler | Fakt | Bajarilishi */
			.pf-card.cols-fakt .pf-row { grid-template-columns: -6fr 1.2fr 1.6fr; }
			.pf-row:first-child { border-top: none; }
			.pf-row-head { background: #fcfcfd; color: #667085; font-size: 13px; font-weight: 600; }
			.pf-col-name { font-size: 15px; color: #101828; }
			.pf-index { color: #98a2b3; }
			.pf-col-num { text-align: right; }
			.pf-fact { font-size: 15px; color: #344054; font-weight: 500; }
			.pf-input {
				width: 100%; max-width: 220px; height: 42px; border: 1px solid #e4e7ec; border-radius: 10px;
				padding: 0 14px; text-align: right; font-size: 15px; color: #101828; outline: none;
				margin-left: auto; display: block;
			}
			.pf-input:focus { border-color: #12b76a; box-shadow: 0 0 0 3px rgba(18, 183, 106, 0.12); }
			.pf-col-bar { display: flex; align-items: center; gap: 12px; }
			.pf-row-head .pf-col-bar { display: block; }
			.pf-chip {
				flex: 0 0 auto; min-width: 52px; text-align: center; padding: 5px 12px;
				border-radius: 999px; font-size: 13px; font-weight: 700;
			}
			.pf-progress { flex: 1; height: 8px; background: #f2f4f7; border-radius: 999px; overflow: hidden; }
			.pf-progress-fill { height: 100%; border-radius: 999px; transition: width 0.4s ease; }
			.pf-row-total { background: #f9fafb; font-weight: 700; }
			.pf-row-total .pf-col-name, .pf-row-total .pf-col-num { color: #101828; font-size: 15px; }
			.pf-empty { padding: 40px; text-align: center; color: #98a2b3; }
			.pf-note { margin-top: 16px; font-size: 13px; color: #98a2b3; line-height: 1.5; }
			@media (max-width: 768px) {
				.pf-row,
				.pf-card.cols-2 .pf-row,
				.pf-card.cols-fakt .pf-row { grid-template-columns: 1.4fr 1fr; row-gap: 8px; }
				.pf-col-bar { grid-column: 1 / -1; }
				.pf-row-head { display: none; }
			}
		`}</style>
	)
}
